/* eslint-disable @typescript-eslint/no-empty-function */
/**
 * Will log to the console if &debug=injector in the url
 */
const injectorLogger = (() => {
  if (process.browser && window.location?.search.match(/debug=injector/)) {
    return {
      debug: console.debug.bind(window.console, "🧞‍♂️"),
      groupCollapsed: console.groupCollapsed.bind(window.console),
      groupEnd: console.groupEnd.bind(window.console),
    };
  } else {
    const NOOP = () => {};
    return {
      debug: NOOP,
      groupEnd: NOOP,
      groupCollapsed: NOOP,
    };
  }
})();

export default injectorLogger;
